/**
 * Query params the RV TYP pipeline expects on the post-submit redirect.
 * `RVCreative=true` forces the RV Creative (Contentful) page in the 2u-edge
 * lambda; `edx_lead` / `rv_source` are tracking params carried by the existing
 * partner flow.
 */
const RV_TYP_QUERY_PARAMS: Record<string, string> = {
  RVCreative: "true",
  edx_lead: "true",
  rv_source: "organic",
};

/**
 * Rewrites a Degree TaxiForm `postSubmitUrl` from the partner-hosted TYP to the
 * RV-owned TYP hosted under the edX domain, gated by the Monarch `routeFlag`.
 *
 * No-op when the flag is off or the URL is missing/relative, so control traffic
 * is byte-for-byte unchanged.
 *
 *   input  : https://onlinecourses.london.ac.uk/thank-you/   (routeFlag: true)
 *   output : /onlinecourses.london.ac.uk/thank-you/?RVCreative=true&edx_lead=true&rv_source=organic
 */
export function modifyDegreePostSubmitUrl(
  postSubmitUrl: string,
  routeFlag?: boolean,
): string {
  if (!routeFlag || !postSubmitUrl) {
    return postSubmitUrl;
  }

  let parsed: URL;
  try {
    parsed = new URL(postSubmitUrl);
  } catch {
    return postSubmitUrl;
  }

  // Strip a leading `info.` so the path matches the RV TYP route key.
  const partnerHost = parsed.hostname.replace(/^info\./, "");

  const params = new URLSearchParams(parsed.search);
  Object.entries(RV_TYP_QUERY_PARAMS).forEach(([key, value]) => {
    params.set(key, value);
  });

  return `/${partnerHost}${parsed.pathname}?${params.toString()}${parsed.hash}`;
}

export default modifyDegreePostSubmitUrl;
